import React, { useState, useEffect, useRef } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import styled from '@emotion/styled';
import Button from '../../../../components/button';
import { Typography, FormControlLabel, Tabs, Tab, Checkbox, TextField as MuiTextField, InputAdornment } from '@material-ui/core';
import { SelectSearch } from '../../../../components/select/SelectSearch';
import { useQuery, useMutation } from 'react-apollo';
import { FIND_FAQ_CONFIGURACAO_UNIDADE, FIND_BY_UNIDADE_CONFIGURACAO_UNIDADE, FIND_PERFIL_PUBLICO_UNIDADE_BY_VENDA_ID } from '../../../../graphql/queryes';
import { UPDATE_FAQ_CONFIGURACAO_UNIDADE, UPDATE_CHATWOOT_CONFIGURACAO_UNIDADE } from '../../../../graphql/mutations';
import { Add, Delete, Visibility, VisibilityOff } from '@material-ui/icons';
import { InputMask } from '../../../../utils/masks';
import { TabGateway } from '../../../configuracao-ia/tabs/TabGateway';
import { TabClassificadores } from '../../../configuracao-ia/tabs/TabClassificadores';

const VIZI_REST_URL = process.env.REACT_APP_BASE_URL_VIZI_REST || (window.location.hostname === 'localhost' ? 'http://localhost:8081' : (process.env.REACT_APP_BASE_URL_VIZI_GQL || '').replace(/\/api\/v1\/graphql$/, ''));


const ModalConfiguracaoIA = ({ open, onClose, venda, setNotification }) => {
  const [formularioTitulosEPerguntas, setFormularioTitulosEPerguntas] = useState({
    'Identificação da Clínica': [
      { tipo: 'input', label: 'Nome fantasia da clínica/unidade', field: 'nomeFantasia', campoEditavel: false },
      { tipo: 'input', label: 'Razão social (opcional)', field: 'razaoSocial', campoEditavel: false },
      { tipo: 'input', label: 'Telefone principal', field: 'telefone', campoEditavel: false, mask: 'phone' },
      { tipo: 'textarea', label: 'Endereço completo', field: 'endereco', campoEditavel: false },
      { tipo: 'textarea', label: 'Observações de acesso/localização', field: 'observacoesAcesso', campoEditavel: false, hint: 'Informações úteis para o paciente chegar. Ex: "Tolerância de 15min", "Estacionamento conveniado ao lado", "Prédio comercial, 3º andar".' }
    ],
    'Serviços e Procedimentos': [
      { tipo: 'textarea', label: 'Liste os principais serviços/procedimentos oferecidos', field: 'servicos', campoEditavel: false },
      { tipo: 'textarea', label: 'Pacotes ou serviços especiais', field: 'pacotesEspeciais', campoEditavel: false, hint: 'Serviços diferenciados que a IA pode destacar ao paciente. Ex: "Check-up executivo", "Pacote gestante", "Programa de emagrecimento".' }
    ],
    'Profissionais de Saúde': [
      { tipo: 'select', label: 'Nome completo dos profissionais com Nº do Conselho + UF e Especialidade(s)', field: 'profissionaisSelecionados', campoEditavel: false },
      { tipo: 'input', label: 'Prefixo', field: 'prefixo', campoEditavel: false },
      { tipo: 'input', label: 'Outro', field: 'profissionaisOutro', campoEditavel: false }
    ],
    'Convênios e Pagamentos': [
      { tipo: 'select', label: 'Lista de convênios aceitos', field: 'conveniosSelecionados', campoEditavel: false },
      { tipo: 'select', label: 'Formas de pagamento aceitas', field: 'formasPagamentoSelecionadas', campoEditavel: false },
      { tipo: 'input', label: 'Outro', field: 'convenioPagamentoOutro', campoEditavel: false },
      { tipo: 'textarea', label: 'Condição especial', field: 'condicoesEspeciais', campoEditavel: false, hint: 'Condições que a IA pode informar ao paciente. Ex: "Primeira consulta grátis", "Parcelamento em 3x sem juros", "10% desconto à vista".' }
    ],
    'Funcionamento e Agendamento': [
      { tipo: 'input', label: 'Horários de funcionamento da clínica', field: 'horariosFuncionamento', campoEditavel: false },
      { tipo: 'select', label: 'O paciente pode escolher o profissional ou apenas a especialidade', field: 'escolhaProfissional', campoEditavel: false },
      { tipo: 'select', label: 'Deseja que a IA envie mensagem de confirmação automática', field: 'confirmacaoAutomatica', campoEditavel: false },
      { tipo: 'textarea', label: 'Orientações pós-agendamento', field: 'orientacoesAdicionais', campoEditavel: false, hint: 'Mensagem que a IA envia após confirmar o agendamento. Ex: "Trazer exames anteriores", "Chegar 15min antes", "Jejum de 8h para exame de sangue".' }
    ],
    'Comunicação': [
      { tipo: 'input', label: 'Linguagem regional', field: 'linguagemRegional', campoEditavel: false, hint: 'Gírias ou expressões locais que a IA pode usar para soar mais natural. Ex: "uai" (MG), "bah" (RS), "oxe" (NE). Deixe vazio para linguagem neutra.' },
      { tipo: 'input', label: 'Público-alvo', field: 'publicoAlvo', campoEditavel: false, hint: 'Descreva o perfil típico dos pacientes: faixa etária, características, necessidades. Ex: "Idosos 60+, precisam de linguagem simples e paciência".' },
      { tipo: 'input', label: 'Situações delicadas', field: 'situacoesDelicadas', campoEditavel: false, hint: 'Temas sensíveis que a IA deve tratar com cuidado ou evitar. Ex: "Não mencionar preços de cirurgia sem o paciente perguntar", "Evitar prometer resultados".' },
      { tipo: 'textarea', label: 'Diferencial de atendimento', field: 'diferencialAtendimento', campoEditavel: false, hint: 'O que torna a clínica única — a IA pode mencionar isso nas conversas. Ex: "Atendimento humanizado, sala VIP para pós-operatório, 20 anos de experiência".' }
    ],
    'FAQ': [
      { tipo: 'textaread', label: 'Faz sedação?', field: 'fazSedacao', campoEditavel: false }
    ],
    'Informações Complementares': [
      { tipo: 'textarea', label: 'Alguma instrução especial para pacientes novos ou de retorno', field: 'instrucoesPacientes', campoEditavel: false }
    ]
  });
  const [formData, setFormData] = useState({
    nomeFantasia: '',
    razaoSocial: '',
    telefone: '',
    endereco: '',
    observacoesAcesso: '',
    servicos: '',
    pacotesEspeciais: '',
    profissionaisSelecionados: [],
    prefixo: '',
    profissionaisOutro: '',
    conveniosSelecionados: [],
    formasPagamentoSelecionadas: [],
    condicoesEspeciais: '',
    horariosFuncionamento: '',
    escolhaProfissional: null,
    confirmacaoAutomatica: null,
    orientacoesAdicionais: null,
    linguagemRegional: '',
    publicoAlvo: '',
    situacoesDelicadas: '',
    diferencialAtendimento: '',
    fazSedacao: null,
    instrucoesPacientes: '',
    novaPergunta: '',
    novaResposta: ''
  });

  const [configData, setConfigData] = useState({
    chatwootUrl: "https://atendimento.apphealth.com.br/",
    chatwootToken: "ZUJFBjEYEuBfK7T4uyzhV2Sj",
    chatwootAccountId: '',
    chatwootInboxId: '',
    utilizaPlugzapi: false,
    utilizaWaba: false,
    utilizaChatwoot: false
  });

  const [profissionaisOptions, setProfissionaisOptions] = useState([]);
  const [formasPagamentoOptions, setFormasPagamentoOptions] = useState([]);
  const [conveniosOptions, setConveniosOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showToken, setShowToken] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [gatewayConfig, setGatewayConfig] = useState({});
  const [classificadoresConfig, setClassificadoresConfig] = useState({});

  // Carregar ia-config da API Vizi REST
  useEffect(() => {
    const apiKey = venda?.unidade?.apiKeyPublic;
    if (!apiKey) return;
    fetch(`${VIZI_REST_URL}/api-vizi/unidades/ia-config`, {
      headers: { 'Authorization': apiKey }
    })
      .then(res => res.ok ? res.json() : {})
      .then(data => {
        const { botName, procedureMode, menuPrincipal, fallbackCurto, fallbackCurtoRepetido, transferProcedureMessage, allowThirdParty, devMode, devModeNumbers, ...classificadores } = data || {};
        setGatewayConfig({ botName, procedureMode, menuPrincipal, fallbackCurto, fallbackCurtoRepetido, transferProcedureMessage, allowThirdParty, devMode, devModeNumbers });
        setClassificadoresConfig(classificadores || {});
      })
      .catch(() => {});
  }, [venda?.unidade?.apiKeyPublic]);

  const { data: faqConfiguracaoUnidade } = useQuery(FIND_FAQ_CONFIGURACAO_UNIDADE, {
    variables: {
      unidadeId: venda.unidade.id
    },
    onCompleted: (data) => {
      if (data?.findFaqConfiguracaoUnidade) {
        const faqData = JSON.parse(data.findFaqConfiguracaoUnidade);
        preencherFormDataComFaq(faqData);
      }
    },
    fetchPolicy: 'no-cache'
  });

  const { data: perfilPublicoUnidade } = useQuery(FIND_PERFIL_PUBLICO_UNIDADE_BY_VENDA_ID, {
    variables: {
      vendaId: venda.id
    },
    skip: !venda.id
  });

  const { data: configuracaoUnidade } = useQuery(FIND_BY_UNIDADE_CONFIGURACAO_UNIDADE, {
    variables: {
      unidadeId: venda.unidade.id
    },
    onCompleted: (data) => {
      if (data?.findByUnidadeConfiguracaoUnidade) {
        const config = data.findByUnidadeConfiguracaoUnidade;
        setConfigData({
          chatwootUrl: config.chatwootUrl || 'https://atendimento.apphealth.com.br',
          chatwootToken: config.chatwootToken || 'ZUJFBjEYEuBfK7T4uyzhV2Sj',
          chatwootAccountId: config.chatwootAccountId || '',
          chatwootInboxId: config.chatwootInboxId || '',
          utilizaPlugzapi: config.utilizaPlugzapi || false,
          utilizaWaba: config.utilizaWaba || false,
          utilizaChatwoot: config.utilizaChatwoot,
          enviaConfirmacaoAntecipaFinalDeSemana: config.enviaConfirmacaoAntecipaFinalDeSemana,
          notificaAzulControleAgendamentoSala: config.notificaAzulControleAgendamentoSala,
          validaAgendamentoMesmoHorario: config.validaAgendamentoMesmoHorario
        });
      }
    },
    fetchPolicy: 'no-cache'
  });
  const [updateFaqConfiguracaoUnidade] = useMutation(UPDATE_FAQ_CONFIGURACAO_UNIDADE);
  const [updateChatWootConfiguracaoUnidade] = useMutation(UPDATE_CHATWOOT_CONFIGURACAO_UNIDADE);


  const novaQuestao = useRef(0)

  const simNaoOptions = [
    { value: 'sim', label: 'Sim' },
    { value: 'nao', label: 'Não' }
  ];

  const profissionalEspecialidadeOptions = [
    { value: 'profissional', label: 'Pode escolher o profissional' },
    { value: 'especialidade', label: 'Apenas a especialidade' }
  ];

  const handleNovaQuestão = (secao) => {
    // Calcula o field UMA vez, de forma sincrona, antes de agendar qualquer
    // setState. Ler novaQuestao.current dentro dos updaters (callbacks lazy do
    // React) causava colisao de field entre perguntas -> espelhamento (#2083).
    const field = `novaPergunta${novaQuestao.current}`;
    novaQuestao.current += 1;
    setFormularioTitulosEPerguntas(prev => ({
      ...prev,
      [secao]: [...prev[secao], { tipo: 'textarea', label: '', field, campoEditavel: true }]
    }));
    setConfigData((prev) => ({ ...prev, [field]: '' }))
  }

  const handleNovaPergunta = (secao, value, field) => {
    setFormularioTitulosEPerguntas((prev) => ({
      ...prev,
      [secao]: prev[secao].map((item) =>
        item.field === field ? { ...item, label: value } : item
      ),
    }));
  };
  const handleDeleteQuestão = (secao, campo) => {
    setFormularioTitulosEPerguntas((prev) => ({
      ...prev,
      [secao]: prev[secao].filter((item) => item.field !== campo.field),
    }));
  };
  const verificarESetarNovasQuestoes = (faqData) => {
    let novoFormularioTitulosEPerguntas = { ...formularioTitulosEPerguntas };

    Object.entries(faqData).forEach(([secao, campos]) => {
      if (novoFormularioTitulosEPerguntas[secao]) {
        const newSecao = campos.map((campo) => {
          const index = novoFormularioTitulosEPerguntas[secao].findIndex((tituloEPergunta) => tituloEPergunta.label === campo.p);
          if (index !== -1) {
            return novoFormularioTitulosEPerguntas[secao][index];
          }
          const novaPergunta = { tipo: 'textarea', label: campo.p, field: `novaPergunta${novaQuestao.current}`, campoEditavel: false };
          novaQuestao.current += 1;
          return novaPergunta;
        });
        novoFormularioTitulosEPerguntas[secao] = newSecao;
      }
    });

    setFormularioTitulosEPerguntas(novoFormularioTitulosEPerguntas);
    return novoFormularioTitulosEPerguntas;
  };


  const handleUtilizaChatwootChange = (e) => {
    const camposPreenchidos = configData.chatwootUrl && configData.chatwootToken && configData.chatwootAccountId && configData.chatwootInboxId;

    if (e.target.checked && !camposPreenchidos) {
      setNotification({
        variant: 'error',
        isOpen: true,
        message: 'Todos os campos do Chatwoot devem estar preenchidos',
      });
      return;
    }

    setConfigData({ ...configData, utilizaChatwoot: e.target.checked });
  };
const preencherFormDataComFaq = (faqData) => {
    if (!faqData) return;

    const formulario = verificarESetarNovasQuestoes(faqData);
    const novoFormData = { ...formData };
    Object.entries(faqData).forEach(([secao, campos]) => {
      campos.forEach(item => {
        Object.entries(formulario).forEach(([secaoForm, camposForm]) => {
          camposForm.forEach(campo => {
            if (campo.label === item.p) {

              novoFormData[campo.field] = item.r;
            }
          });
        });
      });
    });

    setFormData(novoFormData);
  };

  const formatarProfissional = (prof) => {
    let label = prof.nome;
    if (prof.numeroConselho) {
      label += prof.ufConselho ? ` - ${prof.numeroConselho}/${prof.ufConselho}` : ` - ${prof.numeroConselho}`
    }
    if (prof.especialidades && prof.especialidades.length) {
      label += ` - ${prof.especialidades.map(esp => esp.especialidade).join(', ')}`;
    }
    return label;
  };

  const construirResultadoFormulario = () => {
    const resultado = {};

    Object.entries(formularioTitulosEPerguntas).forEach(([secao, campos]) => {
      const camposFiltrados = campos.filter((campo) => campo.label !== "")
      resultado[secao] = camposFiltrados.map(campo => {
        let resposta = formData[campo.field];

        if (Array.isArray(resposta)) {
          resposta = resposta.map(item => item.label).join(', ');
        }
        if (resposta?.label) {
          resposta = resposta.label;
        }

        return {
          p: campo.label,
          r: resposta || ''
        };
      });

    });

    return resultado;
  };
  useEffect(() => {
    if (!faqConfiguracaoUnidade?.findFaqConfiguracaoUnidade) {
      const perfilPublicoUnidadeByVendaId = perfilPublicoUnidade?.findPerfilPublicoUnidadeByVendaId;

      const unidadeData = perfilPublicoUnidadeByVendaId?.unidade || [];
      const endereco = unidadeData.endereco || {};
      const enderecoCompleto = `${endereco.nomeLogradouro || ''} ${endereco.numero || ''}, ${endereco.bairro || ''}, ${endereco.municipio?.nome || ''} - ${endereco.municipio?.uf || ''}, CEP: ${endereco.cep || ''}`;

      setFormData(prev => ({
        ...prev,
        nomeFantasia: unidadeData.nome || unidadeData.nomeFantasia || '',
        razaoSocial: unidadeData.razaoSocial || '',
        telefone: unidadeData.telefonePrincipal || unidadeData.telefonePrincipal || '',
        endereco: enderecoCompleto.trim()
      }));

      if (unidadeData.profissionaisSaude) {
        const options = unidadeData.profissionaisSaude.map(prof => ({
          value: prof.id,
          label: formatarProfissional(prof)
        }));
        setProfissionaisOptions(options);
      }

      if (perfilPublicoUnidadeByVendaId?.formasPagamento) {
        const formasData = perfilPublicoUnidadeByVendaId.formasPagamento;
        const formasOptions = formasData.map(forma => ({
          value: forma.id,
          label: forma.nome
        }));
        setFormasPagamentoOptions(formasOptions);
      }

      if (perfilPublicoUnidadeByVendaId?.convenios) {
        const conveniosData = perfilPublicoUnidadeByVendaId.convenios;
        const conveniosOptions = conveniosData.map(convenio => ({
          value: convenio.id,
          label: convenio.descricao
        }));
        setConveniosOptions(conveniosOptions);
      }
    }
  }, [perfilPublicoUnidade, faqConfiguracaoUnidade]);


  const handleSave = async () => {
    setLoading(true);
    try {
      if (activeTab === 0) {
        const resultado = construirResultadoFormulario();
        await updateFaqConfiguracaoUnidade({
          variables: {
            faq: JSON.stringify(resultado),
            unidadeId: venda.unidade.id
          }
        });
      } else if (activeTab === 1) {
        await updateChatWootConfiguracaoUnidade({
          variables: {
            unidadeId: venda.unidade.id,
            chatwootUrl: configData.chatwootUrl,
            chatwootToken: configData.chatwootToken,
            chatwootAccountId: configData.chatwootAccountId,
            chatwootInboxId: configData.chatwootInboxId,
            utilizaChatwoot: configData.utilizaChatwoot,
            utilizaWaba: configData.utilizaWaba,
            utilizaPlugzapi: configData.utilizaPlugzapi
          }
        });
      } else if (activeTab === 2 || activeTab === 3) {
        const apiKey = venda?.unidade?.apiKeyPublic;
        if (!apiKey) {
          const err = new Error('Unidade sem token de API configurado, não é possível salvar a configuração da IA');
          err.userMessageNode = (
            <span>
              Unidade sem token de API configurado<br />não é possível salvar a configuração da IA
            </span>
          );
          throw err;
        }
        const iaConfig = { ...gatewayConfig, ...classificadoresConfig };
        const response = await fetch(`${VIZI_REST_URL}/api-vizi/unidades/ia-config`, {
          method: 'PUT',
          headers: {
            'Authorization': apiKey,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(iaConfig)
        });
        if (!response.ok) {
          const responseBody = await response.text().catch(() => '');
          const err = new Error(`Erro ao salvar configuração IA (HTTP ${response.status})`);
          err.status = response.status;
          err.responseBody = responseBody;
          if (response.status === 401 || response.status === 403) {
            err.userMessageNode = (
              <span>
                Token de API da unidade inválido ou expirado.<br />Verifique a configuração da unidade e tente novamente.
              </span>
            );
          } else {
            err.userMessageNode = (
              <span>
                Não foi possível salvar a configuração da IA. Tente novamente.
              </span>
            );
          }
          throw err;
        }
      }
      setNotification({
        variant: 'success',
        isOpen: true,
        message: 'Os dados da configuração foram salvos',
      });
      onClose();
    }
    catch (error) {
      console.error('[ModalConfiguracaoIA] Erro ao salvar configurações da IA:', error);
      if (error?.status || error?.responseBody) {
        console.error('[ModalConfiguracaoIA] Resposta não-ok do PUT ia-config:', {
          status: error.status,
          body: error.responseBody
        });
      }
      setNotification({
        variant: 'error',
        isOpen: true,
        message: error?.userMessageNode || error?.userMessage || 'Erro ao salvar as configurações da ia',
      });
    }
    finally {
      setLoading(false);
    }
  };

  const renderCampo = (secao, campo) => {
    const hasValueInFaq = () => {
      if (!faqConfiguracaoUnidade?.findFaqConfiguracaoUnidade) return false;
      const faqData = JSON.parse(faqConfiguracaoUnidade.findFaqConfiguracaoUnidade);
      return Object.values(faqData).some(secao =>
        secao.some(item => item.p === campo.label && item.r)
      );
    };

    const getElements = (field) => {
      if (field === 'profissionaisSelecionados') return profissionaisOptions;
      if (field === 'formasPagamentoSelecionadas') return formasPagamentoOptions;
      if (field === 'conveniosSelecionados') return conveniosOptions;
      if (field === 'escolhaProfissional') return profissionalEspecialidadeOptions;
      return simNaoOptions;
    };
    const elements = !hasValueInFaq() ? getElements(campo.field) : [];
    if (campo.tipo === 'textarea') {
      return (
        <>
             <NovaPerguntaContainer>
            {campo.campoEditavel ?

              <MuiTextField
                variant="outlined"
                size="small"
                fullWidth
                placeholder="Nova pergunta"
                value={campo.label}
                onChange={(e) => handleNovaPergunta(secao, e.target.value, campo.field)}
              />

              :
              <FaqLabel>
                {campo.label}
              </FaqLabel>}
            {campo.hint && <FaqHint>{campo.hint}</FaqHint>}

            <FaqTextareaRow>
              <MuiTextField
                variant="outlined"
                size="small"
                fullWidth
                multiline
                rows={3}
                placeholder={campo.field.includes('novaPergunta') ? "Digite a resposta..." : ""}
                value={formData[campo.field] || ''}
                onChange={(e) => { const v = e.target.value; setFormData((prev) => ({ ...prev, [campo.field]: v })); }}
              />
              {campo.field.includes('novaPergunta') &&
                <DeleteButton onClick={() => handleDeleteQuestão(secao, campo)} title="Remover pergunta">
                  <Delete style={{ fontSize: 14 }} /> Remover
                </DeleteButton>}
            </FaqTextareaRow>
                </NovaPerguntaContainer>
        </>
      );
    }

    if (campo.tipo === 'select') {
      if (!elements.length) {
        return (
          <>
            <FaqLabel>
              {campo.label}
            </FaqLabel>
            {campo.hint && <FaqHint>{campo.hint}</FaqHint>}
            <MuiTextField
              variant="outlined"
              size="small"
              fullWidth
              multiline
              rows={3}
              value={formData[campo.field] || ''}
              onChange={(e) => { const v = e.target.value; setFormData((prev) => ({ ...prev, [campo.field]: v })); }}
            />
          </>
        );
      }
      return (
        <>
          <FaqLabel>
            {campo.label}
          </FaqLabel>
          {campo.hint && <FaqHint>{campo.hint}</FaqHint>}
          <SelectSearch
            placeholder="Selecione..."
            value={formData[campo.field]}
            elements={elements}
            onChange={(value) => setFormData((prev) => ({ ...prev, [campo.field]: value }))}
            isMulti={campo.field === 'profissionaisSelecionados' || campo.field === 'formasPagamentoSelecionadas' || campo.field === 'conveniosSelecionados'}
          />
        </>
      );
    }

    return (
      <>
        <FaqLabel>{campo.label}</FaqLabel>
        {campo.hint && <FaqHint>{campo.hint}</FaqHint>}
        <MuiTextField
          variant="outlined"
          size="small"
          fullWidth
          value={formData[campo.field] || ''}
          onChange={(e) => { const v = e.target.value; setFormData((prev) => ({ ...prev, [campo.field]: v })); }}
          InputProps={campo.mask ? {
            inputComponent: InputMask,
            inputProps: { mask: campo.mask }
          } : undefined}
        />
      </>
    );
  };


  const getFilledCount = (campos) => {
    return campos.filter(campo => {
      const val = formData[campo.field];
      if (Array.isArray(val)) return val.length > 0;
      return val && val.toString().trim() !== '';
    }).length;
  };

  const renderFormulario = () => {
    return (
      <>
        <SectionTitle>Formulário da secretária IA</SectionTitle>
        {Object.entries(formularioTitulosEPerguntas).map(([secao, campos], index) => {
          const filled = getFilledCount(campos);
          const total = campos.length;
          return (
            <FaqSection key={secao}>
              <FaqSectionHeader>
                <span>{secao}</span>
                <FaqBadge filled={filled === total}>{filled}/{total}</FaqBadge>
              </FaqSectionHeader>
              <FaqSectionBody>
                {campos.map((campo) => (
                  <FaqField key={campo.field}>
                    {renderCampo(secao, campo)}
                  </FaqField>
                ))}
                <AddQuestionButton onClick={() => handleNovaQuestão(secao)}>
                  <Add style={{ fontSize: 16 }} /> Adicionar pergunta
                </AddQuestionButton>
              </FaqSectionBody>
            </FaqSection>
          );
        })}
      </>
    );
  };


  const renderChatwoot = () => {
    return (
      <>
        <SectionTitle>Configurações Chatwoot</SectionTitle>
        <FaqSection>
          <FaqSectionHeader>
            <span>Autorizações</span>
          </FaqSectionHeader>
          <FaqSectionBody>
            <FormControlLabel
              style={{ margin: '0px' }}
              control={
                <Checkbox
                  color='primary'
                  checked={configData.utilizaPlugzapi}
                  onChange={(e) => setConfigData({
                    ...configData,
                    utilizaPlugzapi: e.target.checked,
                    utilizaWaba: e.target.checked ? false : configData.utilizaWaba
                  })}
                />
              }
              label="Utiliza plugzapi"
            />
            <FormControlLabel
              style={{ margin: '0px' }}
              control={
                <Checkbox
                  color='primary'
                  checked={configData.utilizaWaba}
                  onChange={(e) => setConfigData({
                    ...configData,
                    utilizaWaba: e.target.checked,
                    utilizaPlugzapi: e.target.checked ? false : configData.utilizaPlugzapi
                  })}
                />
              }
              label="API Oficial WhatsApp (WABA)"
            />
            <FormControlLabel
              style={{ margin: '0px' }}
              control={
                <Checkbox
                  color='primary'
                  checked={configData.utilizaChatwoot}
                  onChange={handleUtilizaChatwootChange}
                />
              }
              label="Utiliza Chatwoot"
            />
          </FaqSectionBody>
        </FaqSection>
        <FaqSection>
          <FaqSectionHeader>
            <span>Credenciais</span>
          </FaqSectionHeader>
          <FaqSectionBody>
            <FaqField>
              <FaqLabel>URL do Chatwoot</FaqLabel>
              <MuiTextField
                variant="outlined"
                size="small"
                fullWidth
                value={configData.chatwootUrl || ''}
                onChange={(e) => setConfigData({ ...configData, chatwootUrl: e.target.value })}
              />
            </FaqField>
            <FaqField>
              <FaqLabel>Token do Chatwoot</FaqLabel>
              <MuiTextField
                variant="outlined"
                size="small"
                fullWidth
                type={showToken ? 'text' : 'password'}
                value={configData.chatwootToken || ''}
                onChange={(e) => setConfigData({ ...configData, chatwootToken: e.target.value })}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowToken(!showToken)}
                        edge="end"
                        size="small"
                      >
                        {showToken ? <VisibilityOff style={{ fontSize: 18 }} /> : <Visibility style={{ fontSize: 18 }} />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </FaqField>
            <FaqFieldRow>
              <FaqField style={{ flex: 1 }}>
                <FaqLabel>Account ID</FaqLabel>
                <MuiTextField
                  variant="outlined"
                  size="small"
                  fullWidth
                  type="number"
                  value={configData.chatwootAccountId || ''}
                  onChange={(e) => setConfigData({ ...configData, chatwootAccountId: e.target.value })}
                />
              </FaqField>
              <FaqField style={{ flex: 1 }}>
                <FaqLabel>Inbox ID</FaqLabel>
                <MuiTextField
                  variant="outlined"
                  size="small"
                  fullWidth
                  type="number"
                  value={configData.chatwootInboxId || ''}
                  onChange={(e) => setConfigData({ ...configData, chatwootInboxId: e.target.value })}
                />
              </FaqField>
            </FaqFieldRow>
          </FaqSectionBody>
        </FaqSection>
      </>
    );
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: 12,
          height: '85vh',
          maxHeight: '750px',
          marginTop: '5vh',
          display: 'flex',
          flexDirection: 'column',
        }
      }}
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          backdropFilter: 'blur(4px)',
        }
      }}
    >
      <AppBar style={{ position: 'relative', backgroundColor: '#1b8c89' }}>
        <Toolbar>
          <Typography style={{ flex: 1, fontSize: '16px', fontWeight: 600 }} variant="h6" color="inherit">
            Configuracoes IA {venda?.unidade?.nomeFantasia ? `— ${venda.unidade.nomeFantasia}` : ''}
          </Typography>
          <IconButton edge="end" color="inherit" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Tabs
        indicatorColor="primary"
        textColor="primary"
        value={activeTab}
        onChange={(e, newValue) => setActiveTab(newValue)}
        variant="fullWidth"
        style={{ backgroundColor: '#fff', borderBottom: '1px solid #e0e0e0' }}
      >
        <Tab label="FAQ" />
        <Tab label="Chatwoot" />
        <Tab label="Gateway" />
        <Tab label="Classificadores" />
      </Tabs>

      <DialogContent style={{ backgroundColor: '#f5f5f5', padding: '24px', overflow: 'auto' }}>
        <FormContainer style={{ maxWidth: 900, margin: '0 auto' }}>
          {activeTab === 0 && renderFormulario()}
          {activeTab === 1 && renderChatwoot()}
          {activeTab === 2 && <TabGateway config={gatewayConfig} onChange={setGatewayConfig} />}
          {activeTab === 3 && <TabClassificadores config={classificadoresConfig} onChange={setClassificadoresConfig} />}
        </FormContainer>
      </DialogContent>

      <ButtonContainer style={{ position: 'sticky', bottom: 0, backgroundColor: '#fff', borderTop: '1px solid #e0e0e0', padding: '12px 24px', display: 'flex', justifyContent: 'flex-end', zIndex: 1 }}>
        <Button onClick={handleSave}>{loading ? 'Salvando...' : 'Salvar'}</Button>
      </ButtonContainer>
    </Dialog>
  );
};

export default ModalConfiguracaoIA;

const FormContainer = styled.div`
  padding: 0px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-family: 'Poppins', 'Helvetica', sans-serif;

  /* Padronizar TODOS os inputs da modal */
  && input,
  && textarea,
  && .MuiInputBase-root,
  && .MuiInputBase-input {
    background-color: #fff !important;
    background: #fff !important;
    border-radius: 6px !important;
    font-size: 13px !important;
    border-color: #e0e0e0 !important;
    color: #1a1a1a !important;
  }

  && .MuiOutlinedInput-root {
    background: #fff !important;
    height: 38px;
  }

  && .MuiOutlinedInput-root.MuiInputBase-multiline {
    height: auto;
  }

  && .MuiOutlinedInput-notchedOutline {
    border-color: #e0e0e0 !important;
  }

  && textarea {
    border: none !important;
    border-radius: 6px !important;
    padding: 8px 10px !important;
  }

  /* Padronizar react-select dentro da modal */
  && .css-yk16xz-control,
  && .css-1pahdxg-control,
  && [class*="-control"] {
    background-color: #fff !important;
    border-color: #e0e0e0 !important;
    border-width: 1px !important;
    border-radius: 6px !important;
    min-height: 38px !important;
    font-size: 13px !important;
    box-shadow: none !important;
  }

  && [class*="-control"]:hover {
    border-color: #bdbdbd !important;
  }

  && [class*="-placeholder"] {
    font-size: 13px !important;
    color: #9e9e9e !important;
  }

  && [class*="-singleValue"],
  && [class*="-multiValue"] {
    font-size: 13px !important;
    color: #1a1a1a !important;
  }
`;

const NovaPerguntaContainer = styled.div`
  display: flex;
  gap: 6px;
  flex-direction: column;
`;

const FaqTextareaRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
`;

const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border: none;
  border-radius: 4px;
  background: #ffebee;
  color: #e53935;
  font-size: 11px;
  cursor: pointer;
  align-self: flex-start;
  transition: all 0.15s;
  &:hover {
    color: #fff;
    background: #e53935;
  }
`;
const SectionTitle = styled.h3`
  font-size: 15px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 12px 0;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
`;

const FaqSection = styled.div`
  background: #fff;
  border: 1px solid #219A97;
  border-radius: 8px;
  margin-bottom: 16px;
  overflow: hidden;
`;

const FaqSectionHeader = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  padding: 8px 16px;
  background: #1b8c89;
  border-bottom: 1px solid #219A97;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const FaqBadge = styled.span`
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 10px;
  background: ${({ filled }) => filled ? 'rgba(255,255,255,0.3)' : 'rgba(255,255,255,0.2)'};
  color: #fff;
`;

const AddQuestionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  border: 1px dashed #bdbdbd;
  border-radius: 6px;
  background: transparent;
  color: #666;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.15s;
  &:hover {
    border-color: #219A97;
    color: #219A97;
    background: #f0faf9;
  }
`;

const FaqSectionBody = styled.div`
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;

  input, textarea {
    font-size: 13px !important;
    padding: 8px 10px !important;
    background: #fff !important;
  }

  textarea {
    min-height: 60px;
  }
`;

const FaqField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
`;

const FaqFieldRow = styled.div`
  display: flex;
  gap: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
`;

const FaqLabel = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: #1a1a1a;
  line-height: 1.4;
  display: block;
`;

const FaqHint = styled.span`
  font-size: 10.5px;
  color: #999;
  line-height: 1.3;
  display: block;
  margin-bottom: 4px;
`;

